<div class="container-fluid no-padding">
  <h3 style="text-align: center; margin: 5px 0 5px 0" class="d-block d-sm-none">
    <span class="blue-font">C</span>omputation <span class="blue-font">A</span>nalytics <span
      class="blue-font">S</span>oftware <span class="blue-font">I</span>nformatics
  </h3>
  <h3 style="text-align: center; margin: 5px 20px 10px 20px" class="d-none d-sm-block d-md-block d-lg-none">
    <span class="blue-font">C</span>omputation <span class="blue-font">A</span>nalytics <span
      class="blue-font">S</span>oftware <span class="blue-font">I</span>nformatics
  </h3>

  <div class="container-fluid no-padding" id="startSection">

    <div class="col-md-12 main-banner">
      <div class="col-md-6 float-end d-none d-lg-block" style="margin: 40px 40px 0 0">
        <h1 class="main-title"><span class="blue-font">CASI</span></h1>
        <h1 class="main-title "><span class="blue-font">C</span>omputation <span class="blue-font">A</span>nalytics</h1>
        <h1 class="main-title"><span class="blue-font">S</span>oftware <span class="blue-font">I</span>nformatics</h1>
      </div>

      <div class="col-6 float-end d-block d-sm-none" style="margin: 20px 0 0 0">
        <h1 class="main-title"><span class="blue-font">CASI</span></h1>
      </div>
      <div class="col-sm-6 float-end d-none d-sm-block d-md-block d-lg-none" style="margin: 40px 40px 0 0">
        <h1 style="font-size: 80px;" class="main-title"><span class="blue-font">CASI</span></h1>
      </div>
    </div>


    <div class=" d-none d-lg-block col-md-12 no-padding" style="background-color: #DDDDDD; margin-bottom: 20px;">
      <div class="row">
        <div class="col-md-1 col-sm-1 no-padding">
          <img src="assets/images/Triangle.png" style="width: 100%;">
        </div>
        <div class="col-md-9 no-padding text-center" style="margin-top: 20px;">
          <h4>CASI is the University of New England’s data transformation hub.</h4>
          <h4>We engineer software and data science tools that extract</h4>
          <h4>new value from data and translate research into innovative solutions.</h4>
        </div>

      </div>
    </div>

    <div class=" d-none d-sm-block d-md-block d-lg-none col-sm-12 no-padding"
      style="background-color: #DDDDDD; margin-bottom: 20px;">
      <div class="row">
        <div class="col-md-1 col-sm-1 no-padding">
          <img src="assets/images/Triangle.png" style="width: 100%;">
        </div>
        <div class="col-sm-10 no-padding text-center">
          <h4>CASI is the University of New England’s data transformation hub.</h4>
          <h4>We engineer software and data science tools that extract</h4>
          <h4>new value from data and translate research into innovative solutions.</h4>
        </div>
      </div>
    </div>


    <div class="col-12 d-block d-sm-none no-padding">
      <div class="row">
        <div class="col-1 no-padding">
          <img src="assets/images/Triangle.png" style="width: 30px">
        </div>
        <div class="col-11">
          <h3 style="text-align: left; margin: 0">CASI is the University of New England’s data transformation hub.</h3>
          <h3 style="text-align: left; margin: 0">We engineer software and data science tools that extract</h3>
          <h3 style="text-align: left; margin: 0 0 10px 0">new value from data and translate research into innovative
            solutions.</h3>
        </div>
      </div>
    </div>

    <div class="container-fluid text-center d-none d-lg-block no-padding banner2">
      <div class="row" style="padding: 0 60px 0 60px; margin: 0;">
        <!-- <div class="col-12" > -->

        <div class="col-4 no-padding">
          <div class="col-md-12 no-padding banner2-icon"><img src="assets/images/Leaf_Icon.png"></div>
          <div class="col-md-12 vertical-line">
            <p class="banner2-text">CASI builds on UNE’s
              successful track
              record in delivering
              research impact
              through innovative
              software solutions
              for agricultural,
              environmental and
              health partners.</p>
          </div>
        </div>

        <div class="col-4 no-padding">
          <div class="col-md-12 no-padding banner2-icon"><img src="assets/images/Magnify_Icon.png"></div>
          <div class="col-md-12 vertical-line">
            <p class="banner2-text">Data science can be
              applied across all
              research disciplines
              through successful
              partnering of software
              and data specialists
              with domain experts.</p>
          </div>
        </div>

        <div class="col no-padding">
          <div class="col-md-12 no-padding banner2-icon"><img src="assets/images/Network_Icon.png"></div>
          <div class="col-md-12 vertical-line-empty">
            <p class="banner2-text">Our vision is to be a
              national leader and
              partner of choice in
              research-focused
              data transformation –
              by adding value and
              improving productivity
              from data.</p>
          </div>
        </div>

        <!-- </div> -->


      </div>

    </div>

    <div class="container-fluid d-none d-sm-block d-md-block d-lg-none no-padding banner2">
      <div class="row" style="padding: 30px 15px; margin: 0;">
        <div class="row" style="margin: 0 0 20px 0;">
          <div class="col-2 no-padding banner2-icon"><img src="assets/images/Leaf_Icon.png" style="width:60px"></div>
          <div class="col-9">
            <p class="banner2-text">CASI builds on UNE’s
              successful track
              record in delivering
              research impact
              through innovative
              software solutions
              for agricultural,
              environmental and
              health partners.</p>
          </div>
        </div>

        <div class="row" style="margin: 0 0 20px 0;">
          <div class="col-2 no-padding banner2-icon"><img src="assets/images/Magnify_Icon.png" style="width:60px">
          </div>
          <div class="col-9">
            <p class="banner2-text">Data science can be
              applied across all
              research disciplines
              through successful
              partnering of software
              and data specialists
              with domain experts.</p>
          </div>
        </div>

        <div class="row" style="margin: 0;">
          <div class="col-2 no-padding banner2-icon"><img src="assets/images/Network_Icon.png" style="width:60px">
          </div>
          <div class="col-9">
            <p class="banner2-text">Our vision is to be a
              national leader and
              partner of choice in
              research-focused
              data transformation –
              by adding value and
              improving productivity
              from data.</p>
          </div>
        </div>

      </div>

    </div>

    <div class="container-fluid d-block d-sm-none no-padding banner2">
      <div class="row" style="padding: 30px 15px 15px 15px; margin: 0;">
        <div class="col-12 banner2-icon"><img style="width:50px" src="assets/images/Leaf_Icon.png"></div>
        <div class="col-12">
          <p class="banner2-text">CASI builds on UNE’s
            successful track
            record in delivering
            research impact
            through innovative
            software solutions
            for agricultural,
            environmental and
            health partners.</p>
        </div>
        <div class="col-12 banner2-icon"><img style="width:50px" src="assets/images/Magnify_Icon.png"></div>
        <div class="col-12">
          <p class="banner2-text">Data science can be
            applied across all
            research disciplines
            through successful
            partnering of software
            and data specialists
            with domain experts.</p>
        </div>

        <div class="col-12 banner2-icon"><img style="width:50px" src="assets/images/Network_Icon.png"></div>
        <div class="col-12">
          <p class="banner2-text">Our vision is to be a
            national leader and
            partner of choice in
            research-focused
            data transformation –
            by adding value and
            improving productivity
            from data.</p>
        </div>
      </div>

    </div>

  </div>

  <div class="row home-section" id="aboutSection">
    <h2 class=" d-none d-lg-block" style="margin-bottom: 60px"><fa-icon class="fa-solid fa-duotone blue-font"
        [icon]="['fad', 'caret-right']"></fa-icon> Why work with
      <span class="blue-font">us?</span>
    </h2>
    <h2 class="d-block d-lg-none"><fa-icon class="fa-solid fa-duotone blue-font"
        [icon]="['fad', 'caret-right']"></fa-icon> Why work with <span class="blue-font">us?</span></h2>


    <div class="col-md-3 col-sm-3 d-none d-sm-block">
      <img src="assets/images/Globe.png" style="width: 100%;">
    </div>
    <div class="col-12 d-block d-sm-none">
      <img src="assets/images/Globe.png" style="width: 120px;">
    </div>
    <div class="col-md-8  d-none d-lg-block" style="margin-top: 40px;">
      <p>We have a strong track record of success, earning credibility with researchers and industry/government
        stakeholders.</p>
      <p>We bring specialist expertise in computational science, data analytics,
        machine learning, mathematics, statistics, software engineering, data
        visualisation and other research-focused digital technologies.</p>
      <p>We are committed to assisting research teams translate their research
        outputs and data into quality outcomes and impact.</p>
      <p>We embody UNE’s strategic commitment to be a national leader and
        partner in data transformation.</p>
    </div>

    <div class="col-sm-9  d-none d-sm-block d-md-block d-lg-none">
      <p>We have a strong track record of success, earning credibility with researchers and industry/government
        stakeholders.</p>
      <p>We bring specialist expertise in computational science, data analytics,
        machine learning, mathematics, statistics, software engineering, data
        visualisation and other research-focused digital technologies.</p>
      <p>We are committed to assisting research teams translate their research
        outputs and data into quality outcomes and impact.</p>
      <p>We embody UNE’s strategic commitment to be a national leader and
        partner in data transformation.</p>
    </div>


    <div class="d-block d-sm-none col-12" style="margin-top: 20px;">
      <p>We have a strong track record of success, earning credibility with researchers and industry/government
        stakeholders.</p>
      <p>We bring specialist expertise in computational science, data analytics,
        machine learning, mathematics, statistics, software engineering, data
        visualisation and other research-focused digital technologies.</p>
      <p>We are committed to assisting research teams translate their research
        outputs and data into quality outcomes and impact.</p>
      <p>We embody UNE’s strategic commitment to be a national leader and
        partner in data transformation.</p>
    </div>

    <div class="row">
      <div class="col-12" style="text-align: right; padding: 0 40px 0 0;">
        <a (click)="backToTop()"><fa-icon class="fa-solid fa-duotone" [icon]="['fad', 'chevron-up']"
            size="2x"></fa-icon></a>
      </div>
    </div>
    <div class="bar-divider col-md-11 col-12 col-sm-12 no-padding"></div>

  </div>

  <div class="row home-section" id="peopleSection">
    <h2 class=" d-none d-lg-block" style="margin-bottom: 60px"><fa-icon class="fa-solid fa-duotone blue-font"
        [icon]="['fad', 'caret-right']"></fa-icon> Our <span class="blue-font">people</span></h2>
    <h2 class="d-block d-lg-none"><fa-icon class="fa-solid fa-duotone blue-font"
        [icon]="['fad', 'caret-right']"></fa-icon> Our <span class="blue-font">people</span>
    </h2>

    <div class="col-md-3 col-sm-3 d-none d-sm-block"><img src="assets/images/Johan_Profile.png" style="width: 100%;"></div>

    <div class="col-12 d-block d-sm-none">
      <img src="assets/images/Johan_Profile.png" style="width: 120px; margin-bottom: 20px;">
    </div>

    <div class="col-md-8 col-12 col-sm-9">
      <h4>Manager - Mr Johan Boshoff</h4>
      <p>Johan leads the CASI team of software engineers and data scientists.
        With a specialisation in research-based software engineering and
        data science, Johan is well positioned to lead a team of data science
        professionals focusing on transforming research for impact and
        productivity improvement. Johan has proven experience in developing
        software solutions through his own business as well as recent experience
        working in the research sector.</p>
      <p>The CASI team has a strong software engineering base complemented
        by skills in data analytics, data architecture, data modelling, machine
        learning, data visualisation and database management. Data science is
        a critical element supporting contemporary research and the CASI team
        now includes a broad range of leading edge data science capabilities.</p>
      <p>The CASI team is supported by UNE expertise in computation, statistics
        and mathematics areas as well as research strengths across the full
        range of UNE research disciplines and specialist research facilities.</p>
      <p>Further information on UNE research strengths and facilities can be
        found at <a href="https://www.une.edu.au/research" target="_blank">www.une.edu.au/research</a></p>
    </div>
    <div class="row">
      <div class="col-12" style="text-align: right; padding: 0 40px 0 0;">
        <a (click)="backToTop()"><fa-icon class="fa-solid fa-duotone" [icon]="['fad', 'chevron-up']"
            size="2x"></fa-icon></a>
      </div>
    </div>
    <!-- <div class="bar-divider col-md-11 col-12 col-sm-12 no-padding"></div> -->
  </div>

  <div class="row home-section banner3" id="servicesSection">
    <h2 class="d-none d-lg-block" style="padding-top: 30px; margin-bottom:60px"><fa-icon
        class="fa-solid fa-duotone blue-font" [icon]="['fad', 'caret-right']"></fa-icon> <span class="white-text"> Our
      </span><span class="blue-font">services</span></h2>
    <h2 class="d-block d-lg-none" style="padding-top: 20px;"><fa-icon class="fa-solid fa-duotone blue-font"
        [icon]="['fad', 'caret-right']"></fa-icon> <span class="white-text"> Our </span><span
        class="blue-font">services</span></h2>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-3  d-none d-lg-block">
          <p style="font-size: 28px;line-height: 32px;" class="white-text light-font">We develop
            close working
            relationships with
            our clients, offering
            the following
            services:</p>
        </div>
        <div class="col-sm-12  d-none d-sm-block d-md-block d-lg-none">
          <p style="font-size: 24px;line-height: 26px;" class="white-text light-font">We develop
            close working
            relationships with
            our clients, offering
            the following
            services:</p>
        </div>
        <div class="col-12 d-block d-sm-none">
          <p style="font-size: 18px;line-height: 18px;" class="white-text light-font">We develop
            close working
            relationships with
            our clients, offering
            the following
            services:</p>
        </div>
        <div class="col-md-8 col-sm-8 col-sm-offset-1 col-md-offset-0 d-none d-sm-block">
          <ul style="padding: 0 0 0 20px;">
            <li class="white-text">Software engineering</li>
            <li class="white-text">Data analytics</li>
            <li class="white-text">Data architecture</li>
            <li class="white-text">Machine learning</li>
            <li class="white-text">Data visualization</li>
            <li class="white-text">Data modelling and statistics</li>
            <li class="white-text">Data aggregation</li>
            <li class="white-text">Big Data management</li>
            <li class="white-text">Tailored sensor and hardware solutions</li>
            <li class="white-text">Data hosting</li>
          </ul>
          <p class="white-text">Particular projects may utilise one or many of these services.
            We work with clients to determine what is the best solution to
            deliver the required results.</p>
          <p class="white-text">CASI operates on a project basis and undertakes projects of all sizes.
            Pricing is based on the scope of the requirements and the types of
            capabilities needed.</p>

        </div>
        <div class="col-12 d-block d-sm-none" style="margin-bottom: 20px">
          <ul style="padding: 0 0 0 20px;">
            <li class="white-text">Software engineering</li>
            <li class="white-text">Data analytics</li>
            <li class="white-text">Data architecture</li>
            <li class="white-text">Machine learning</li>
            <li class="white-text">Data visualization</li>
            <li class="white-text">Data modelling and statistics</li>
            <li class="white-text">Data aggregation</li>
            <li class="white-text">Big Data management</li>
            <li class="white-text">Tailored sensor and hardware solutions</li>
            <li class="white-text">Data hosting</li>
          </ul>
          <p class="white-text">Particular projects may utilise one or many of these services.
            We work with clients to determine what is the best solution to
            deliver the required results.</p>
          <p class="white-text">CASI operates on a project basis and undertakes projects of all sizes.
            Pricing is based on the scope of the requirements and the types of
            capabilities needed.</p>

        </div>

      </div>

    </div>
    <div class="row">
      <div class="col-12" style="text-align: right; padding: 0 40px 0 0;">
        <a (click)="backToTop()"><fa-icon class="fa-solid fa-duotone" [icon]="['fad', 'chevron-up']"
            size="2x"></fa-icon></a>
      </div>
    </div>
    <!-- <div class="bar-divider col-md-11 col-12 col-sm-12 no-padding"></div> -->

  </div>

  <div class="row home-section" id="approachSection">
    <h2 class="d-none d-lg-block" style="margin-bottom: 60px"><fa-icon class="fa-solid fa-duotone blue-font"
        [icon]="['fad', 'caret-right']"></fa-icon> Our <span class="blue-font">approach</span></h2>
    <h2 class="d-block d-lg-none"><fa-icon class="fa-solid fa-duotone blue-font"
        [icon]="['fad', 'caret-right']"></fa-icon> Our <span class="blue-font">approach</span></h2>

    <div class="col-md-3 col-sm-3 d-none d-sm-block"><img src="assets/images/Computer_Screen.png" style="width: 100%;"></div>
    <div class="col-12 d-block d-sm-none">
      <img src="assets/images/Computer_Screen.png" style="width: 120px; margin-bottom: 20px;">
    </div>
    <div class="col-md-8 col-sm-9 col-12">
      <h4>We partner with researchers,
        industry groups and government by:</h4>
      <ul style="padding: 0 0 0 20px;">
        <li style="margin-bottom: 10px"><b>Clarifying the opportunity</b> – developing a shared understanding of the
          research, the data and the expected outcomes.</li>
        <li style="margin-bottom: 10px"><b>Assessing what data science solutions are most applicable</b> – looking at
          options including software engineering, data analytics, prediction and machine learning, and data
          visualisation.</li>
        <li style="margin-bottom: 10px"><b>Developing solutions in an agile manner</b> - working closely with partners
          to achieve a shared understanding of progress with opportunities for iteration to ensure high value and best
          possible outcomes.</li>
        <li style="margin-bottom: 10px"><b>Delivering fully tested and reliable solutions that achieve the impacts
            sought</b> – we pride ourselves on the quality of our work and consistently exceed client expectations.</li>
      </ul>
      <p>We adopt a highly client-centric approach based on strong partnering, often involving industry/government
        groups, UNE domain experts and the CASI team. This ensures our solutions are fit-for-purpose and of high
        quality.</p>
    </div>
    <div class="row">
      <div class="col-12" style="text-align: right; padding: 0 40px 0 0;">
        <a (click)="backToTop()"><fa-icon class="fa-solid fa-duotone" [icon]="['fad', 'chevron-up']"
            size="2x"></fa-icon></a>
      </div>
    </div>
    <div class="bar-divider col-md-11 col-12 col-sm-12 no-padding"></div>
  </div>

  <div class="row home-section" style="padding-bottom: 40px;" id="examplesSection">
    <a id="projects" class="nav-link section-font d-none d-lg-block" routerLinkActive="active" routerLink="/casi-projects"
      style="color: unset;">
      <h2 style="margin-bottom: 60px"><fa-icon class="fa-solid fa-duotone blue-font"
          [icon]="['fad', 'caret-right']"></fa-icon> Our <span class="blue-font">projects</span></h2>
    </a>
    <a class="nav-link section-font d-block d-lg-none" routerLinkActive="active" routerLink="/projects" style="color: unset;">
      <h2  style="margin-bottom: 20px"><fa-icon class="fa-solid fa-duotone blue-font"
          [icon]="['fad', 'caret-right']"></fa-icon> Our <span class="blue-font">projects</span></h2>
    </a>
    <div class="container-fluid text-center">
      <div>
        <div class="d-flex flex-wrap" style="margin-bottom: 30px;">

          <div class="card hcard">
            <a href="https://environer.une.edu.au" target="_blank"
              style="display: block; background-color: #231f20; height: 70px; width: 230px;">
              <img src="assets/images/env_logo.png" style="max-height: 70px; max-width: 100%;">
            </a>
            <div class="card-body">
            </div>
            <div class="card-footer">
              <a class="nav-link" routerLinkActive="active" routerLink="/casi-projects" fragment="environer"
                style="position: relative; bottom: 0;">FIND OUT MORE</a>
            </div>
          </div>
          <!-- <div class="image-tile p-2">
            <a href="https://environer.une.edu.au" target="_blank"
              style="display: block; background-color: #231f20; height: 70px; width: 230px;">
              <img src="assets/images/env_logo.png" style="max-height: 70px; max-width: 100%;">
            </a>
            <br>
            <a class="nav-link" routerLinkActive="active" routerLink="/casi-project" fragment="environer"
              style="position: relative; bottom: 0;">FIND OUT MORE</a>
          </div> -->

          <div class="card hcard">
            <a href="https://atrium.une.edu.au" target="_blank">
              <img src="assets/images/ATRIUM_Logo.png" style="max-height: 70px; max-width: 100%;">
            </a>
            <div class="card-body">
            </div>
            <div class="card-footer">
              <a class="nav-link" routerLinkActive="active" routerLink="/casi-projects" fragment="atrium"
                style="position: relative; bottom: 0;">FIND OUT MORE</a>
            </div>
          </div>
          <!-- <div class="image-tile p-2">
            <a href="https://atrium.une.edu.au" target="_blank">
              <img src="assets/images/ATRIUM_Logo.png" style="max-height: 70px; max-width: 100%;">
            </a>
            <br>
            <a ui-sref="projects({project:'atrium'})" style="position: relative; bottom: 0;">FIND OUT MORE</a>
          </div> -->

          <div class="card hcard">
            <a href="https://resdataopt.une.edu.au" target="_blank">
              <img src="assets/images/rdo_logo.png" style="max-height: 70px; max-width: 100%;">
            </a>
            <div class="card-body">
            </div>
            <div class="card-footer">
              <a class="nav-link" routerLinkActive="active" routerLink="/casi-projects" fragment="rdo"
                style="position: relative; bottom: 0;">FIND OUT MORE</a>
            </div>
          </div>
          <!-- <div class="image-tile p-2">
            <a href="https://resdataopt.une.edu.au" target="_blank">
              <img src="assets/images/rdo_logo.png" style="max-height: 70px; max-width: 100%;">
            </a>
            <br>
            <a ui-sref="projects({project:'rdo'})" style="position: relative; bottom: 0;">FIND OUT MORE</a>
          </div> -->

          <div class="card hcard">
            <a href="https://pest.une.edu.au" target="_blank">
              <img src="assets/images/pest-logo.jpg" style="max-height: 80px; max-width: 100%; margin-top: -10px;">
            </a>
            <div class="card-body">
            </div>
            <div class="card-footer">
              <a class="nav-link" routerLinkActive="active" routerLink="/casi-projects" fragment="pest"
                style="position: relative; bottom: 0;">FIND OUT MORE</a>
            </div>
          </div>
          <!-- <div class="image-tile p-2">
            <a href="https://pest.une.edu.au" target="_blank">
              <img src="assets/images/pest-logo.jpg" style="max-height: 80px; max-width: 100%; margin-top: -10px;">
            </a>
            <br>
            <a ui-sref="projects({project:'pest'})" style="position: relative; bottom: 0;">FIND OUT MORE</a>
          </div> -->

          <div class="card hcard">
            <a ui-sref="projects({project:'ecohealth'})">
              <img src="assets/images/ecohealth_logo.png" style="max-height: 70px; max-width: 100%;">
            </a>
            <div class="card-body">
            </div>
            <div class="card-footer">
              <a class="nav-link" routerLinkActive="active" routerLink="/casi-projects" fragment="ecohealth"
                style="position: relative; bottom: 0;">FIND OUT MORE</a>
            </div>
          </div>
          <!-- <div class="image-tile p-2">
            <a ui-sref="projects({project:'ecohealth'})">
              <img src="assets/images/ecohealth_logo.png" style="max-height: 70px; max-width: 100%;">
            </a>
            <br>
            <a ui-sref="projects({project:'ecohealth'})" style="position: relative; bottom: 0;">FIND OUT MORE</a>
          </div> -->

          <div class="card hcard">
            <a href="https://turnedworm.une.edu.au" target="_blank">
              <img src="assets/images/worm-logo.png" style="max-height: 70px; max-width: 100%;">
            </a>
            <div class="card-body">
            </div>
            <div class="card-footer">
              <a class="nav-link" routerLinkActive="active" routerLink="/casi-projects" fragment="worm"
                style="position: relative; bottom: 0;">FIND OUT MORE</a>
            </div>
          </div>
          <!-- <div class="image-tile p-2">
            <a href="https://turnedworm.une.edu.au" target="_blank">
              <img src="assets/images/worm-logo.png" style="max-height: 70px; max-width: 100%;">
            </a>
            <br>
            <a ui-sref="projects({project:'worm'})" style="position: relative; bottom: 0;">FIND OUT MORE</a>
          </div> -->

          <div class="card hcard">
            <a href="https://ncw-beadleherbarium.une.edu.au" target="_blank">
              <img src="assets/images/herb_logo.png" style="max-height: 70px; max-width: 100%;">
            </a>
            <div class="card-body">
            </div>
            <div class="card-footer">
              <a class="nav-link" routerLinkActive="active" routerLink="/casi-projects" fragment="herbarium"
                style="position: relative; bottom: 0;">FIND OUT MORE</a>
            </div>
          </div>
          <!-- <div class="image-tile p-2">
            <a href="https://ncw-beadleherbarium.une.edu.au" target="_blank">
              <img src="assets/images/herb_logo.png" style="max-height: 70px; max-width: 100%;">
            </a>
            <br>
            <a ui-sref="projects({project:'herbarium'})" style="position: relative; bottom: 0;">FIND OUT MORE</a>
          </div> -->

          <div class="card hcard">
            <a href="https://enrichinglivestock.une.edu.au" target="_blank">
              <img src="assets/images/eal_logo.jpg"
                style="max-height: 100px; max-width: 100%; margin-top: -20px; margin-left: -30px;">
            </a>
            <div class="card-body">
            </div>
            <div class="card-footer">
              <a class="nav-link" routerLinkActive="active" routerLink="/casi-projects" fragment="enrichinglivestock"
                style="position: relative; bottom: 0;">FIND OUT MORE</a>
            </div>
          </div>
          <!-- <div class="image-tile p-2">
            <a href="https://enrichinglivestock.une.edu.au" target="_blank">
              <img src="assets/images/eal_logo.jpg"
                style="max-height: 100px; max-width: 100%; margin-top: -20px; margin-left: -30px;">
            </a>
            <br>
            <a ui-sref="projects({project:'enrichinglivestock'})" style="position: relative; bottom: 0;">FIND OUT
              MORE</a>
          </div> -->

          <div class="card hcard">
            <a href="https://adri.bnhcrc.com.au" target="_blank">
              <img src="assets/images/ADRI_Logo.png" style="max-height: 70px; max-width: 100%;">
            </a>
            <div class="card-body">
            </div>
            <div class="card-footer">
              <a class="nav-link" routerLinkActive="active" routerLink="/casi-projects" fragment="adri"
                style="position: relative; bottom: 0;">FIND OUT MORE</a>
            </div>
          </div>
          <!-- <div class="image-tile p-2">
            <a href="https://adri.bnhcrc.com.au" target="_blank">
              <img src="assets/images/ADRI_Logo.png" style="max-height: 70px; max-width: 100%;">
            </a>
            <br>
            <a ui-sref="projects({project:'adri'})" style="position: relative; bottom: 0;">FIND OUT MORE</a>
          </div> -->

          <div class="card hcard">
            <a href="https://ag360.com.au" target="_blank">
              <img src="assets/images/Ag360_Logo.png" style="max-height: 80px; max-width: 100%; margin-top: -10px;">
            </a>
            <div class="card-body">
            </div>
            <div class="card-footer">
              <a class="nav-link" routerLinkActive="active" routerLink="/casi-projects" fragment="ag360"
                style="position: relative; bottom: 0;">FIND OUT MORE</a>
            </div>
          </div>
          <!-- <div class="image-tile p-2">
            <a href="https://ag360.com.au" target="_blank">
              <img src="assets/images/Ag360_Logo.png" style="max-height: 80px; max-width: 100%; margin-top: -10px;">
            </a>
            <br>
            <a ui-sref="projects({project:'ag360'})" style="position: relative; bottom: 0;">FIND OUT MORE</a>
          </div> -->

          <div class="card hcard">
            <a href="https://ag360-education.une.edu.au" target="_blank">
              <img src="assets/images/Ag_360_Education_Logo.png"
                style="max-height: 80px; max-width: 100%; margin-top: -10px;">
            </a>
            <div class="card-body">
            </div>
            <div class="card-footer">
              <a class="nav-link" routerLinkActive="active" routerLink="/casi-projects" fragment="ag360education"
                style="position: relative; bottom: 0;">FIND OUT MORE</a>
            </div>
          </div>
          <!-- <div class="image-tile p-2">
            <a href="https://ag360-education.une.edu.au" target="_blank">
              <img src="assets/images/Ag_360_Education_Logo.png"
                style="max-height: 80px; max-width: 100%; margin-top: -10px;">
            </a>
            <br>
            <a ui-sref="projects({project:'ag360education'})" style="position: relative; bottom: 0;">FIND OUT MORE</a>
          </div> -->

          <div class="card hcard">
            <a href="https://ramselect.com.au" target="_blank">
              <img src="assets/images/RamSelect_Logo.jpg" style="max-height: 50px; max-width: 100%; margin-top: 10px;">
            </a>
            <div class="card-body">
            </div>
            <div class="card-footer">
              <a class="nav-link" routerLinkActive="active" routerLink="/casi-projects" fragment="ramselect"
                style="position: relative; bottom: 0;">FIND OUT MORE</a>
            </div>
          </div>
          <!-- <div class="image-tile p-2">
            <a href="https://ramselect.com.au" target="_blank">
              <img src="assets/images/RamSelect_Logo.jpg" style="max-height: 50px; max-width: 100%; margin-top: 10px;">
            </a>
            <br>
            <a ui-sref="projects({project:'ramselect'})" style="position: relative; bottom: 0;">FIND OUT MORE</a>
          </div> -->

          <div class="card hcard">
            <a href="https://ramselect-training.une.edu.au/" target="_blank">
              <img src="assets/images/RamSelect_Training_Logo.png" style="max-height: 70px; max-width: 100%;">
            </a>
            <div class="card-body">
            </div>
            <div class="card-footer">
              <a class="nav-link" routerLinkActive="active" routerLink="/casi-projects" fragment="ramselecttraining"
                style="position: relative; bottom: 0;">FIND OUT MORE</a>
            </div>
          </div>
          <!-- <div class="image-tile p-2">
            <a href="https://ramselect-training.une.edu.au/" target="_blank">
              <img src="assets/images/RamSelect_Training_Logo.png" style="max-height: 70px; max-width: 100%;">
            </a>
            <br>
            <a ui-sref="projects({project:'ramselecttraining'})" style="position: relative; bottom: 0;">FIND OUT
              MORE</a>
          </div> -->

          <div class="card hcard">
            <a href="https://sheepdna.com.au" target="_blank">
              <img src="assets/images/sheepdna_logo.png" style="max-height: 50px; max-width: 100%; margin-top: 20px;">
            </a>
            <div class="card-body">
            </div>
            <div class="card-footer">
              <a class="nav-link" routerLinkActive="active" routerLink="/casi-projects" fragment="sheepdna"
                style="position: relative; bottom: 0;">FIND OUT MORE</a>
            </div>
          </div>
          <!-- <div class="image-tile p-2">
            <a href="https://sheepdna.com.au" target="_blank">
              <img src="assets/images/sheepdna_logo.png" style="max-height: 50px; max-width: 100%; margin-top: 20px;">
            </a>
            <br>
            <a ui-sref="projects({project:'sheepdna'})" style="position: relative; bottom: 0;">FIND OUT MORE</a>
          </div> -->

          <div class="card hcard">
            <img src="assets/images/ldl_logo.png" style="max-height: 80px; max-width: 100%;">
            <div class="card-body">
            </div>
            <div class="card-footer">
              <a class="nav-link" routerLinkActive="active" routerLink="/casi-projects" fragment="ldlinsights"
                style="position: relative; bottom: 0;">FIND OUT MORE</a>
            </div>
          </div>
          <!-- <div class="image-tile p-2">
            <img src="assets/images/ldl_logo.png" style="max-height: 80px; max-width: 100%;">
            <br>
            <a ui-sref="projects({project:'ldlinsights'})" style="position: relative; bottom: 0;">FIND OUT MORE</a>
          </div> -->

          <div class="card hcard">
            <img src="assets/images/sugarmaps_logo.png" style="max-height: 60px; max-width: 100%;">
            <div class="card-body">
            </div>
            <div class="card-footer">
              <a class="nav-link" routerLinkActive="active" routerLink="/casi-projects" fragment="sugarmaps"
                style="position: relative; bottom: 0;">FIND OUT MORE</a>
            </div>
          </div>
          <!-- <div class="image-tile p-2">
            <img src="assets/images/sugarmaps_logo.png" style="max-height: 60px; max-width: 100%;">
            <br>
            <a ui-sref="projects({project:'sugarmaps'})" style="position: relative; bottom: 0;">FIND OUT MORE</a>
          </div> -->

          <div class="card hcard">
            <img src="assets/images/mobselect_logo.png" style="max-height: 80px; max-width: 100%;">
            <div class="card-body">
            </div>
            <div class="card-footer">
              <a class="nav-link" routerLinkActive="active" routerLink="/casi-projects" fragment="mobselect"
                style="position: relative; bottom: 0;">FIND OUT MORE</a>
            </div>
          </div>
          <!-- <div class="image-tile p-2">
            <img src="assets/images/mobselect_logo.png" style="max-height: 80px; max-width: 100%;">
            <br>
            <a ui-sref="projects({project:'mobselect'})" style="position: relative; bottom: 0;">FIND OUT MORE</a>
          </div> -->

          <div class="card hcard">
            <img src="assets/images/labreport_logo.png" style="max-height: 80px; max-width: 100%;">
            <div class="card-body">
            </div>
            <div class="card-footer">
              <a class="nav-link" routerLinkActive="active" routerLink="/casi-projects" fragment="labreport"
                style="position: relative; bottom: 0;">FIND OUT MORE</a>
            </div>
          </div>
          <!-- <div class="image-tile p-2">
            <img src="assets/images/labreport_logo.png" style="max-height: 80px; max-width: 100%;">
            <br>
            <a ui-sref="projects({project:'labreport'})" style="position: relative; bottom: 0;">FIND OUT MORE</a>
          </div> -->

          <div class="card hcard">
            <img src="assets/images/hens_logo.png" style="max-height: 80px;">
            <div class="card-body">
            </div>
            <div class="card-footer">
              <a class="nav-link" routerLinkActive="active" routerLink="/casi-projects" fragment="hens"
                style="position: relative; bottom: 0;">FIND OUT MORE</a>
            </div>
          </div>
          <!-- <div class="image-tile p-2">
            <img src="assets/images/hens_logo.png" style="max-height: 80px;">
            <br>
            <a ui-sref="projects({project:'hens'})" style="position: relative; bottom: 0;">FIND OUT MORE</a>
          </div> -->

          <div class="card hcard">
            <img src="assets/images/lagoons_logo.png" style="max-height: 80px; max-width: 100%;">
            <div class="card-body">
            </div>
            <div class="card-footer">
              <a class="nav-link" routerLinkActive="active" routerLink="/casi-projects" fragment="lagoons"
                style="position: relative; bottom: 0;">FIND OUT MORE</a>
            </div>
          </div>
          <!-- <div class="image-tile p-2">
            <img src="assets/images/lagoons_logo.png" style="max-height: 80px; max-width: 100%;">
            <br>
            <a ui-sref="projects({project:'lagoons'})" style="position: relative; bottom: 0;">FIND OUT MORE</a>
          </div> -->

        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-12" style="text-align: right; padding: 0 40px 0 0;">
        <a style="color: inherit;" (click)="backToTop()"><fa-icon class="fa-solid fa-duotone"
            [icon]="['fad', 'chevron-up']" size="2x"></fa-icon></a>
        <hr style="border-top: 2px solid;">
      </div>
    </div>

  </div>

</div>
